/**
 * Percorso guidato della societa senza squadre nella stagione corrente (V05):
 * stagione, squadre, incroci, con la spunta ricavata dalla matrice di V48.
 *
 * Niente e memorizzato: chi si ferma a meta e torna trova spuntato cio che i
 * dati dicono fatto, e chi disattiva tutte le squadre ritrova il passo da
 * fare. Il percorso sparisce con il primo incrocio della stagione corrente,
 * perche da li V05 ha schede da mostrare.
 */

import type { Matrice } from '../amministrazione/matrice.js';
import { segnaProssimo } from '../comuni/passi.js';

export type ChiavePassoSocieta = 'stagione' | 'squadre' | 'incroci';

export interface PassoSocieta {
  chiave: ChiavePassoSocieta;
  fatto: boolean;
  prossimo: boolean;
}

export interface Percorso {
  passi: PassoSocieta[];
  /**
   * Stagioni ci sono ma nessuna e corrente: il primo passo non e crearne una
   * ma impostarla. Succede solo se la corrente e stata tolta da fuori, perche
   * la prima stagione creata diventa corrente da sola.
   */
  stagioneDaImpostare: boolean;
}

export function percorsoSocieta(m: Matrice): Percorso {
  const corrente = m.stagioni.find((s) => s.corrente);
  return {
    passi: segnaProssimo([
      { chiave: 'stagione' as const, fatto: Boolean(corrente) },
      { chiave: 'squadre' as const, fatto: m.squadre.some((s) => s.attiva) },
      {
        chiave: 'incroci' as const,
        fatto: Boolean(corrente && m.celle.some((c) => c.stagioneId === corrente.id)),
      },
    ]),
    stagioneDaImpostare: !corrente && m.stagioni.length > 0,
  };
}
